import { render, staticRenderFns } from "./MultiSelectCompany.vue?vue&type=template&id=61aef5fd&scoped=true"
import script from "./MultiSelectCompany.vue?vue&type=script&lang=js"
export * from "./MultiSelectCompany.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectCompany.vue?vue&type=style&index=0&id=61aef5fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aef5fd",
  null
  
)

export default component.exports